import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import EmptyState from '@/components/templates/EmptyState';
import { LoginContext } from '@/hooks/useLogin';
import useMobileView from '@/hooks/useMobileView';
import { __, _s, _t } from '@/locale';
import { useContext } from 'react';

const FavoritesLoginModal = ({ onClose, isOpen }: { onClose: () => void; isOpen: boolean }) => {
  const { isMobileView } = useMobileView();
  const loginContext = useContext(LoginContext);
  return (
    <Modal isOpen={isOpen}>
      <Modal.Content newDesign={true} contentPadding={false} floating={!isMobileView}>
        <Modal.Header floating={!isMobileView} newDesign={true} title="Logga in" onClose={onClose} />
        <EmptyState
          body={_s('loginForFavs')}
          title={__('loginForFavsTitle')}
          icon={<img src="/images/illustrations/favorites2.png" alt="" />}
          cta={loginContext.renderLoginButton({
            label: _t('favorites.emptyState.button'),
            size: 'sm',
            initiatedFrom: 'place_page_favorited',
            trackPromptEvent: true,
          })}
        />
      </Modal.Content>
    </Modal>
  );
};

export default FavoritesLoginModal;
